import React from "react";
import { Link, DisabledPrompt } from "bcms-react";
import { UICheckbox } from "components/ui";

import "./styles.css";

/**
 * @function MobileACHParticipantsRow
 * @param {STRING} nickname - Sets the participant's nickname text.
 * @param {STRING} createdDate - Sets the participant's created date text.
 * @param {STRING} accountNumber - Sets the participant's account number text.    
 * @param {STRING} routingNumber - Sets the participant's routing number text.   
 * @param {STRING} status - Sets the participant's current status text.
 * @return {React.Component}
 * @exported true
 * @description This is the table row used for the mobile ACH Participants table view.
 */
export default function MobileACHParticipantsRow(props) {
    const participant = props.participant ?? {};
    const onParticipantRowChange = props.onParticipantRowChange ?? (() => {});
    const nickname = props.nickname ?? "[nickname]";
    const createdDate = props.createdDate ?? "[createdDate]";
    const accountNumber = props.accountNumber ?? "[accountNumber]";
    const routingNumber = props.routingNumber ?? "[routingNumber]";
    const status = props.status ?? "[status]";

    return (
        <div className="mobile-ach-participants-row">
            <div className="mobile-ach-participants-row-container flex-container align-center">
                <div className="set-width participant-checkbox">
                    <UICheckbox label="" value={ participant.isSelected === "true" } onChange={ onParticipantRowChange(participant) } />
                </div>
                <div className="flex-width participant-details">
                    <div className="participant-detail-container flex-container nickname-detail">
                        <div className="flex-width">
                            <DisabledPrompt>
                                <Link>
                                    <span className="detail-text">{ participant.nickname }</span>
                                </Link>
                            </DisabledPrompt>
                        </div>
                    </div>
                    <div className="participant-detail-container flex-container account-detail">
                        <div className="flex-width">
                            <span className="detail-label">Account</span>
                        </div>
                        <div className="flex-width text-right">
                            <span className="detail-text">{ `${ participant.accountType } ${ participant.number }` }</span>
                        </div>
                    </div>
                    <div className="participant-detail-container flex-container routing-number-detail">
                        <div className="flex-width">
                            <span className="detail-label">Routing Number</span>
                        </div>
                        <div className="flex-width text-right">
                            <span className="detail-text">{ participant.routing }</span>
                        </div>
                    </div>
                    <div className="participant-detail-container flex-container status-detail">
                        <div className="flex-width">
                            <span className="detail-label">Status</span>
                        </div>
                        <div className="flex-width text-right">
                            <span className="detail-text">{ participant.status }</span>
                        </div>
                    </div>
                    <div className="participant-detail-container flex-container status-detail">
                        <div className="flex-width">
                            <span className="detail-label">Created</span>
                        </div>
                        <div className="flex-width text-right">
                            <span className="detail-text">{ participant.createdDate.format("m/d/Y") } {participant.createdTime}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
